export const ordinalSuffix = (number: number): string => {
  const hundreds = number % 100;

  if (hundreds >= 10 && hundreds <= 20) {
    return 'th';
  }

  const tens = number % 10;

  switch (tens) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

export const formatOrdinalLabel = (number: number): string => (
  `${number}${ordinalSuffix(number)}`
);
